import React, { useCallback, useEffect, useState } from 'react'
import {
  InteractorReturnHeaderCheckAvailable,
  InteractorReturnRequest,
} from '../../interactors/Main'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { cleanNumber, currencyFormat } from '../../utility/Helpers'
import { InputCurrency } from '../Main'
import { confirmationAlert, showAlert } from '../../utility/SweetAlert'
import { useSelector } from 'react-redux'

const WideCardBalanceCard = ({
  bill,
  returnValue,
  setReturnValue,
  returnSummary,
  setReturnSummary,
  handleInputPrice,
  handleBlurInputPrice,
  handleRequestReturn,
}) => {
  const { t } = useTranslation()
  // const totalAmount = Number(
  //   bill?.total_amount - (bill?.delivery_cost || 0) - (bill?.delivery_insurance_cost || 0) || 0,
  // )
  const available = returnSummary?.total_retur_available + bill?.retur_amount || 0

  return (
    <div className="col-12 px-3 mb-3">
      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        {/* Header */}
        <div
          className="p-4 text-white"
          style={{
            backgroundColor: '#0062b0',
            borderRadius: '20px 20px 20px 20px',
            minHeight: 200,
          }}
        >
          <h6 className="text-uppercase fw-semibold text-white mb-5">{t('title.return_wallet')}</h6>

          <div className="d-flex">
            <div className="container">
              <div className="row  justify-content-end">
                <h5 className=" text-white mb-1">{t('title.return_available')}</h5>
              </div>
              <div className="row  justify-content-end">
                <h3 className="fw-bold display-6 mb-0">{currencyFormat(available, 'IDR')}</h3>
              </div>
            </div>
          </div>
        </div>

        <div
          className="d-flex gap-2 align-items-start rounded-3 p-3 mt-2 mb-3 border"
          style={{
            backgroundColor: '#e8f2fb',
            borderColor: '#cce0f5',
          }}
        >
          <span
            className="badge rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 text-white"
            style={{
              width: 20,
              height: 20,
              fontSize: 11,
              backgroundColor: '#0062b0',
            }}
          >
            i
          </span>

          <p className="mb-0 small lh-base px-3" style={{ color: '#004d8c' }}>
            {t('message.return_message_warning')}
          </p>
        </div>

        <div className="row align-items-start px-2">
          <div className="col-6 mb-3 px-3">
            <div className="card border-0 rounded-3 bg-light p-3 h-100">
              <small
                className="text-secondary text-uppercase fw-semibold mb-1"
                style={{ fontSize: 10 }}
              >
                {t('title.bill.invoice_code')}
              </small>
              <strong className="brand-text">{bill?.invoice_code ? bill.invoice_code : '-'}</strong>
            </div>
          </div>

          {/* <div className="col-6 mb-3 px-3">
            <div className="card border-0 rounded-3 bg-light p-3 h-100">
              <small
                className="text-secondary text-uppercase fw-semibold mb-1"
                style={{ fontSize: 10 }}
              >
                {t('title.bill.total_amount')}
              </small>
              <strong className="brand-text">
                {bill?.total_amount ? currencyFormat(totalAmount, 'IDR') : '-'}
              </strong>
            </div>
          </div> */}

          <div className="col-6 mb-3 px-3">
            <div className="card border-0 rounded-3 bg-light p-3 h-100">
              <small
                className="text-secondary text-uppercase fw-semibold mb-1"
                style={{ fontSize: 10 }}
              >
                {t('title.bill_status')}
              </small>
              <strong className="brand-text">
                {bill?.status ? t(`status.bill.${bill.status}`) : '-'}
              </strong>
            </div>
          </div>

          <div className="col-12 mb-3 px-3">
            <div className="card border-0 rounded-3 bg-light p-3 h-100">
              <small
                className="text-secondary text-uppercase fw-semibold mb-2"
                style={{ fontSize: 10 }}
              >
                {t('title.bill.total_amount')}
              </small>

              {/* TAGIHAN */}
              <div className="d-flex justify-content-between">
                <span className="text-secondary">{t('title.bill.total_amount')}</span>
                <strong>
                  {bill?.total_amount ? currencyFormat(bill?.total_amount, 'IDR') : '-'}
                </strong>
              </div>

              {/* RETUR */}
              <div className="d-flex justify-content-between">
                <span className="text-secondary">{t('title.bill.return_amount_invoice')}</span>
                <strong>
                  {bill?.retur_amount
                    ? currencyFormat(bill?.retur_amount, 'IDR')
                    : currencyFormat(0, 'IDR')}
                </strong>
              </div>

              <hr className="my-2" />

              {/* TOTAL AKHIR */}
              <div className="d-flex justify-content-between">
                <strong>{t('title.bill.total_amount_initial')}</strong>
                <strong className="brand-text">
                  {bill?.total_amount
                    ? currencyFormat((bill.total_amount || 0) + (bill.retur_amount || 0), 'IDR')
                    : '-'}
                </strong>
              </div>
            </div>
          </div>

          {/* <div
            className="d-flex gap-2 align-items-start rounded-3 p-3 mt-2 mb-3 border"
            style={{
              backgroundColor: '#e8f2fb',
              borderColor: '#cce0f5',
            }}
          >
            <span
              className="badge rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 text-white"
              style={{
                width: 20,
                height: 20,
                fontSize: 11,
                backgroundColor: '#0062b0',
              }}
            >
              i
            </span>

            <p className="mb-0 small lh-base px-3" style={{ color: '#004d8c' }}>
              {t('message.return_amount')}
            </p>
          </div> */}

          <div className="col-12 px-3 my-1">
            <hr className="m-0 border-secondary-subtle" />
          </div>
        </div>

        {/* Amount Input */}
        <div className="p-4 border-radius-10 ">
          <p className="text-uppercase fw-semibold text-secondary small mb-2">
            {t('title.enter_amount')}
          </p>

          <div
            className="d-flex align-items-center gap-2 rounded-3 p-3 border border-radius-10 lead"
            style={{
              backgroundColor: '#e8f2fb',
              borderColor: '#cce0f5',
            }}
          >
            <span
              className="badge fw-semibold px-3 py-3 flex-shrink-0 border-radius-10 lead"
              style={{
                backgroundColor: '#cce0f5',
                color: '#004d8c',
              }}
            >
              RP.
            </span>

            <InputCurrency
              id="delivery_fee"
              value={returnValue}
              setValue={setReturnValue}
              onChange={(e) => handleInputPrice(e)}
              onBlur={(e) => handleBlurInputPrice(e)}
              currency="IDR"
              decimal={2}
              zeroMinValue={false}
              wrapperStyle={{
                flex: 1,
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                background: 'transparent',
                border: 'none',
                boxShadow: 'none',
              }}
              currencyStyle={{ display: 'none' }}
              inputStyle={{
                border: 'none',
                boxShadow: 'none',
                background: 'transparent',
                textAlign: 'right',
                fontSize: '2rem',
                fontWeight: '700',
                color: '#004d8c',
                padding: 0,
                height: 'auto',
                outline: 'none',
              }}
            />
          </div>
        </div>

        {/* Actions */}
        <div className="d-flex justify-content-end gap-2 px-4 pb-4">
          <button
            type="button"
            className="btn text-white rounded-3 fw-semibold "
            style={{ backgroundColor: '#469a84' }}
            onClick={handleRequestReturn}
          >
            {t('button.apply_return')}
          </button>
        </div>
      </div>
    </div>
  )
}

WideCardBalanceCard.propTypes = {
  bill: PropTypes.object.isRequired,
  returnValue: PropTypes.number.isRequired,
  setReturnValue: PropTypes.func.isRequired,
  returnSummary: PropTypes.object.isRequired,
  setReturnSummary: PropTypes.func.isRequired,
  handleInputPrice: PropTypes.func.isRequired,
  handleBlurInputPrice: PropTypes.func.isRequired,
  handleRequestReturn: PropTypes.func.isRequired,
}

const WideCardOrderReturn = (data) => {
  const { account } = useSelector((state) => state.account)
  const { bill } = data
  const [returnValue, setReturnValue] = useState(0)
  const { t } = useTranslation()
  const { returnHeaderCheckAvailable } = InteractorReturnHeaderCheckAvailable()
  const { returnRequest } = InteractorReturnRequest()
  const [returnSummary, setReturnSummary] = useState({})
  const [payload] = useState({
    customer_account_uid: bill.bill_to_account_uid,
    store_uid: bill.store_uid,
  })

  const getMaxLimit = useCallback(() => {
    const totalAmount = Number(bill?.total_amount + bill?.retur_amount || 0)
    // const totalDeliveryCost = Number(bill?.delivery_cost || 0)
    // const totalDeliveryInsuranceCost = Number(bill?.delivery_insurance_cost || 0)

    // const totalReturn = Number(returnSummary?.total_retur_available + bill.retur_amount || 0)

    // const netAmount = totalAmount - totalDeliveryCost - totalDeliveryInsuranceCost

    return Math.max(0, totalAmount)
    // return Math.min(totalAmount, totalReturn)
    // return Math.min(netAmount, totalReturn)
  }, [bill])

  const handleInputPrice = (val) => {
    const inputValue = cleanNumber(val?.value || 0)

    setReturnValue(inputValue)
  }

  const handleBlurInputPrice = (val) => {
    const inputValue = cleanNumber(val?.value || 0)

    const maxLimit = getMaxLimit()

    const finalValue = Math.min(inputValue, maxLimit)

    setReturnValue(finalValue)
  }

  const handleRequestReturn = async () => {
    const isValid = returnValue > 0

    if (!isValid) {
      return showAlert({
        icon: 'error',
        message: t('message.less_than_one'),
      })
    }

    const isConfirm = await confirmationAlert({
      title: t('title.are_you_sure'),
      message: t('message.confirmation_apply_return'),
      icon: 'warning',
    })

    const payload = {
      uid: bill.uid,
      retur_amount: returnValue,
      updated_by: account.full_name,
      initial_status: 'REQUEST',
      uid_transaction: bill?.reference_uid,
    }

    if (isConfirm) {
      returnRequest(payload)
    }
  }

  useEffect(() => {
    if (Object.keys(bill).length > 0) {
      returnHeaderCheckAvailable(payload, setReturnSummary, () => {})
    }
  }, [bill, payload, returnHeaderCheckAvailable])

  return (
    <div className="container-fluid px-0">
      <div className="row justify-content-center py-3 mb-2 border-bottom">
        <div className="col-12 px-4">
          <h5 className="fw-bold mb-0">{t('title.invoice_detail')}</h5>
        </div>
      </div>

      <WideCardBalanceCard
        bill={bill}
        returnValue={returnValue}
        setReturnValue={setReturnValue}
        returnSummary={returnSummary}
        setReturnSummary={setReturnSummary}
        handleInputPrice={handleInputPrice}
        handleBlurInputPrice={handleBlurInputPrice}
        handleRequestReturn={handleRequestReturn}
      />
    </div>
  )
}

WideCardOrderReturn.propTypes = {
  data: PropTypes.object,
}

export default WideCardOrderReturn
